export const validationIncludesRequired = (formFieldOptions) => {
  return !!formFieldOptions?.required;
};
